<template>
    <el-form :model="item" status-icon label-width="170px" label-position="top">

        <el-form-item :label="$t('stream_form.name')" prop="name" :error="error_form.name">
            <el-input v-model="item.name" :placeholder="$t('stream_form.name_placeholder')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('use_domain')" prop="domain_id" :error="error_form.domain_id">
            <el-select
                    v-model="item.domain_id"
                    clearable
                    :placeholder="$t('default_domain')"
                    :disabled="!domains.length"
                    style="width:100%"
            >
                <el-option
                        v-for="item in domains"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item :label="$t('offer')" prop="offer_id" :error="error_form.offer_id">
            <el-select
                    v-model="item.offer_id"
                    filterable
                    style="width:100%"
            >
                <el-option
                        v-for="item in offers"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item :label="$t('landings')" prop="landingIDs" :error="error_form.landingIDs" v-if="landings">
            <LandingSelect v-model="item.landingIDs" :data="landings" />
        </el-form-item>

        <el-form-item :label="$t('prelandings')" prop="landingIDs" :error="error_form.landingIDs" v-if="prelandings">
            <LandingSelect v-model="item.landingIDs" :data="prelandings" />
        </el-form-item>

        <el-form-item>
            <el-checkbox v-model="use_postback">{{ $t('use_postback') }}</el-checkbox>

        </el-form-item>

        <div v-if="use_postback">
            <el-form-item label="URL Регистрации" prop="name" :error="error_form.postback_url">
                <el-input v-model="item.postback_url" placeholder="http://example.com/tracker/registration.php?click_id={click_id}&payout={payout}"></el-input>
            </el-form-item>

            <el-form-item label="URL Подписки" prop="name" :error="error_form.trial_postback_url" v-if="use_postback">
                <el-input v-model="item.trial_postback_url" placeholder="http://example.com/tracker/trial.php?click_id={click_id}&payout={payout}&event_id={event_id}"></el-input>
            </el-form-item>

            <el-form-item label="URL Платежа" prop="name" :error="error_form.pay_postback_url" v-if="use_postback">
                <el-input v-model="item.pay_postback_url" placeholder="http://example.com/tracker/pay.php?click_id={click_id}&payout={payout}&event_id={event_id}"></el-input>
            </el-form-item>

            <div class="form-help">
                Макросы для постбэка:
                <div><strong>{click_id}, {source}, {sub1}, {sub2}, {sub3}, {sub4}, {sub5}</strong> - Параметры переданные в ссылке потока</div>
                <div>Пример передачи параметра в ссылке потока: ?click_id={your click id} - ваш кликайди трекера</div>

                <div><strong>{payout}</strong> - Сумма выплаты</div>
                <div><strong>{currency}</strong> - Валюта выплаты</div>
                <div><strong>{event_id}</strong> - Внутренний идентификатор транзакции платежей</div>
            </div>
        </div>


        <el-form-item>
            <el-button type="primary" @click="save" :loading="loading_form">{{ item.id ? $t('save'): $t('create') }}</el-button>
            <el-button @click="cancel">{{ $t('cancel') }}</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    import LandingSelect from "./LandingSelect";
    export default {
        name: "StreamEdit",
        components: {LandingSelect},
        props: {
            item: [Object]
        },
        data () {
            return {
                error_form: {},
                loading_form: false,
                offers: [],
                domains: [],
                use_postback: false
            }
        },
        computed: {
            selectedOffer() {
                return this.offers.find(item => item.id === this.item.offer_id);
            },
            landings() {
                if (this.selectedOffer) {
                    let landings = this.selectedOffer.landings.filter(item => item.type === 'landing');
                    if (landings.length) {
                        return landings;
                    }
                }
            },
            prelandings() {
                if (this.selectedOffer) {
                    let prelandings = this.selectedOffer.landings.filter(item => item.type === 'prelanding');
                    if (prelandings.length) {
                        return prelandings;
                    }
                }
            }
        },
        created () {
            this.error_form = {};
            this.use_postback = !!this.item.postback_url || !!this.item.trial_postback_url || !!this.item.pay_postback_url
        },
        mounted () {
            this.$axios.get('/offers?fields=id,name&expand=landings&c[available]=1').then((res) => {
                this.offers = res.data;
            });

            this.$axios.get('/domains').then((res) => {
                this.domains = res.data;
            });
        },
        watch:{
            'item'(){
                this.error_form = {}
                this.use_postback = !!this.item.postback_url || !!this.item.trial_postback_url || !!this.item.pay_postback_url
            },
        },
        methods: {
            save () {
                this.loading_form=true;

                if (!this.use_postback) {
                    this.item.postback_url = ''
                    this.item.trial_postback_url = ''
                    this.item.pay_postback_url = ''
                }

                if (this.item.id) {
                    this.update();
                } else {
                    this.create();
                }
            },
            update () {
                this.$axios.patch('/streams/' + this.item.id + '?expand=landings,offer', this.item).then((res) => {
                    this.error_form = {};
                    this.loading_form = false;
                    this.$message({
                        type: 'success',
                        message: this.$t('notice.stream_saved')
                    });
                    this.cancel();
                    this.$emit('update', res.data)
                }).catch((error) => {
                    this.error_form = error.response.data;
                    this.loading_form=false;
                });
            },
            create () {
                this.$axios.post('/streams?expand=landings,offer', this.item).then((res) => {
                    this.error_form = {};
                    this.loading_form = false;
                    this.$message({
                        type: 'success',
                        message: this.$t('notice.stream_added')
                    });
                    this.cancel();
                    this.$emit('create', res.data)
                }).catch((error) => {
                    this.error_form = error.response.data;
                    this.loading_form=false;
                });
            },
            cancel () {
                this.$emit('cancel')
            }
        }
    }
</script>

<style scoped>

</style>
